/* eslint-disable */
import {
  Checkbox,
  Flex,
  Popover,
  Radio,
  Space,
  Button,
  Dropdown,
  Modal,
  message,
  Tag,
} from "antd";
import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  CaretDownOutlined,
  OneToOneOutlined,
  SyncOutlined,
  MenuOutlined,
  EditOutlined,
  PlusOutlined,
  FileTextOutlined,
  FileSearchOutlined,
  DeleteOutlined
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";

import { CustomTable } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import AddModal from "./component/AddModal";
import UploadModal from "./component/UploadModal";
export default function InsuranceIndex() {
  const addModalRef = useRef(null);
  const UploadModalRef = useRef(null);
  // 默认选中的值
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const tableHeadRef = useRef({});
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const paginationRef = useRef({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  const [insuranceTypeOptions, setInsuranceTypeOptions] = useState([]);

  const buildColumns = (checkedValues = selectedItems) =>
    initColumns.map((item) => ({
      ...item,
      hidden:
        checkedValues?.length > 0
          ? !checkedValues.includes(item.dataIndex)
          : false,
    }));

  // 处理选项变化
  const handleChange = (checkedValues) => {
    setSelectedItems(checkedValues);
    setColumns(buildColumns(checkedValues));
  };

  const showModal = () => {
    addModalRef.current?.setModelAdd();
  };
  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );

  const handleMenuClick = async (e, record) => {

    if (e.key === "Update") {
      UploadModalRef.current?.open(record);
      return;
    }
    if (e.key === "Delete") {
      Modal.confirm({
        title: "Confirm Delete",
        content: "Are you sure you want to delete this Type?",
        okText: "Delete",
        okType: "danger",
        cancelText: "Cancel",
        onOk: async () => {
          try {
            const res = await http.get(api.getInsuranceTypeDel, {
              params: { id: record?.id },
            });
            if (res?.code === "1") {
              message.success("Delete Successfully.");
              getTableListFn(pagination.current, pagination.pageSize, tableHead);
            } else {
              message.error(res?.msg );
            }
          } catch (err) {
            message.error("Request Error");
          }
        },
      });
    }
  };

  const getInsuranceTypeList = async () => {
    try {
      const res = await http.get(api.getInsuranceType);
      const data = res?.data || res;
      const list = (data || []).map((item) => ({
        value: String(item.id),
        label: item.insuranceType,
      }));

      setInsuranceTypeOptions(list);
    } catch (err) {
      message.error("Request Error");
    }
  };
  const insuranceTypeMap = useMemo(() => {
    const map = {};
    insuranceTypeOptions.forEach((item) => {
      map[item.value] = item.label;
    });
    return map;
  }, [insuranceTypeOptions]);

  const initTableHead = {
    role: null,
    module: null,
    firstName: null,
    dateTimeRequest: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  useEffect(() => {
    tableHeadRef.current = tableHead;
    paginationRef.current = pagination;
  }, [tableHead, pagination]);

  const getInsuranceTypeStatus = async (id, status) => {
    return http.get(api.getInsuranceTypeStatus, {
      params: { id, status },
    });
  };

  const tableFilterFn = (event, key, type = "Input") => {
    if (type === "DatePicker") {
      setTableHead((prev) => {
        const updatedTableHead = {
          ...prev,
        };
        getTableListFn(1, pagination.pageSize, updatedTableHead);
        return updatedTableHead;
      });
      return;
    }
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "bankId",
      align: "center",
      width: 60,
      render: (text, record) => (
        <Dropdown
          menu={{
            items: [     
        
                  {
                key: "Update",
                icon: (
                  <FileTextOutlined style={{ color: "#00c0ef", fontSize: 17 }} />
                ),
                label: <div>Update Insurance Type</div>,
              }, 
                       {
                key: "Delete",
                icon: (
                  <DeleteOutlined style={{ color: "#00c0ef", fontSize: 17 }} />
                ),
                label: <div>Delete Insurance Type</div>,
              }, 
           
            ],
            onClick: (e) => handleMenuClick(e, record),
          }}
          trigger={["click"]}
        >
          <MenuOutlined
            style={{ cursor: "pointer", fontSize: 16, color: "#0e78a9" }}
          />
        </Dropdown>
      ),
    },
      {
      title: "Insurance Type",
      dataIndex: "insuranceType",
      titleType: "Select",
      width: 200,
      selectOptions: insuranceTypeOptions,
      onChange: (e) => tableFilterFn(e, "insuranceType", "Select"),
      render: (value) =>
       insuranceTypeMap[String(value)] ?? value ?? ""
    },
   

    {
      title: "Remark",
      dataIndex: "remark",
      titleType: "Input",
      width: 100,
      onChange: (e) => tableFilterFn(e, "remark"),
    },
        {
      title: "Status",
      dataIndex: "status",
      width: 110,
      align: "center",
      titleType: "Select",
      selectOptions: [
        { label: "All", value: "" },
        { label: "Active", value: "1" },
        { label: "Inactive", value: "2" },
      ],
      onChange: (value) => tableFilterFn(value, "status", "Select"),
      render: (_, record) => {
        const value = Number(record.status);
        if (!value) return "-";

        const handleClick = () => {
          const newValue = value === 1 ? 2 : 1;
          const statusText = newValue === 1 ? "Active" : "Inactive";
          const currentPage = paginationRef.current.current;
          const currentPageSize = paginationRef.current.pageSize;

          Modal.confirm({
            title: "Confirm Status Change",
            content: (
              <span>
                Are you sure you want to change the status to
                <span style={{ color: "#1890ff", fontWeight: 500 }}>
                  {" "}
                  {statusText}
                </span>
                ?
              </span>
            ),
            okText: "Confirm",
            cancelText: "Cancel",
            onOk: async () => {
              try {
                const res = await getInsuranceTypeStatus(record.id, newValue);
                if (res?.code === "1") {
                  message.success(res?.msg || "Status updated successfully");
                  getTableListFn(
                    currentPage,
                    currentPageSize,
                    tableHeadRef.current
                  );
                } else {
                  message.error(res?.msg || "Operation failed");
                }
              } catch (e) {
                const backendMsg =
                  e?.response?.data?.msg ||
                  e?.msg ||
                  e?.message ||
                  "Network error";
                message.error(backendMsg);
              }
            },
            style: { top: "40%" },
          });
        };

        return value === 1 ? (
          <Tag
            color="green"
            style={{ cursor: "pointer" }}
            onClick={handleClick}
          >
            Active
          </Tag>
        ) : (
          <Tag color="red" style={{ cursor: "pointer" }} onClick={handleClick}>
            Inactive
          </Tag>
        );
      },
    },

    {
      title: "Create By Name",
      dataIndex: "createByName",
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "createByName"),
    },
    {
      title: "Update By Name",
      dataIndex: "updateByName",
      titleType: "Input",
      onChange: (e) => tableFilterFn(e, "updateByName"),
    },

   
  ];

  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    const response = await http.get(api.getInsuranceTypeShow, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data.list || []).map((item, index) => ({
      ...item,
      "#": (params.page - 1) * params.count + index + 1,
      key: item.id,
    }));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const { field: orderField, order: orderType, columnKey } = sorter;
    if (columnKey === "trust") {
      const tableHeadTemp = {
        ...tableHead,
        orderField,
        orderType,
      };
      getTableListFn(pagination.current, pagination.pageSize, tableHeadTemp);
    } else {
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    }
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
    setColumns(buildColumns(transformedList2));
  };

  useEffect(() => {
    initColunmsFn();
    getInsuranceTypeList();
    getTableListFn(1, 25);
  }, [refreshKey]);

  useEffect(() => {
    if (!selectedItems.length) return;
    setColumns(buildColumns(selectedItems));
  }, [insuranceTypeOptions]);

  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div>
          <Button className="btnNew" onClick={showModal}>
            <PlusOutlined />
            New
          </Button>
        </div>
        <div className="min-width">
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={() => setRefreshKey(+new Date())}>
              <SyncOutlined />
            </Radio.Button>
            <Radio.Button value="b">
              <Popover content={content} title="" trigger="click">
                <OneToOneOutlined />
                <CaretDownOutlined className="ft12" />
              </Popover>
            </Radio.Button>
          </Radio.Group>
        </div>
      </Flex>
      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="350px"
        tableCss="maintenanceTable"
        rowKey="id"
      />
      <AddModal
        ref={addModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />
    
      <UploadModal
        ref={UploadModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />
    </div>
  );
}
